export default function CopyLinkIco() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.70696 11.3644L11.3639 5.70756M3.58602 7.82865L2.1718 9.24285C0.609706 10.8049 0.609246 13.3378 2.17135 14.8999C3.73345 16.462 6.26686 16.4615 7.82896 14.8994L9.24166 13.4854M7.82806 3.58565L9.24226 2.17144C10.8044 0.609335 13.3368 0.609615 14.8989 2.17172C16.461 3.73381 16.4609 6.2665 14.8988 7.82855L13.4853 9.24275"
        stroke="#7F56D9"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
